import { Button, Flex, Form, Modal, Typography } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { OpenNoteType, ProcessType } from 'src/components/v2/Button/BtnHandleList';

const { Text } = Typography;

interface Props {
  open: OpenNoteType;
  setOpen: React.Dispatch<React.SetStateAction<OpenNoteType>>;
  handleAddNote: (note: string, processType?: ProcessType) => void;
}

type FormStateType = {
  note: string;
};

const initFormState: FormStateType = {
  note: ''
};

export default function AddNote({ open, setOpen, handleAddNote }: Props) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [formState, setFormState] = useState(initFormState);

  const handleSubmit = () => {
    form
      .validateFields()
      .then(() => {
        handleAddNote(formState.note, open.processType);
        setOpen({ isOpen: false });
        form.resetFields();
        setFormState(initFormState);
      })
      .catch(() => {});
  };

  const handleCancel = () => {
    setOpen({ isOpen: false });
    form.resetFields();
    setFormState(initFormState);
  };

  return (
    <Modal
      title={
        <Flex gap={4}>
          <Text>Nội dung phê duyệt</Text>
        </Flex>
      }
      centered
      maskClosable={false}
      open={open.isOpen}
      onOk={handleSubmit}
      onCancel={handleCancel}
      footer={[
        <Button key='back' onClick={handleCancel}>
          {t('action.cancel')}
        </Button>,
        <Button key='submit' type='primary' onClick={handleSubmit}>
          {t('action.submit')}
        </Button>
      ]}
    >
      <Form form={form} layout='vertical'>
        <Form.Item label={false} name='note'>
          <TextArea
            onChange={(e) => setFormState({ note: e.target.value })}
            rows={2}
            placeholder='Nhập nội dung phê duyệt'
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
